import { useEffect }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { push, RouterState }        from "connected-react-router";

import { APIState }         from "../store/API/types";
import { ApplicationState } from "../store";


const useInitialRouting = () => {
  const {token} = useSelector<ApplicationState, APIState>(state => state.API);
  const {location} = useSelector<ApplicationState, RouterState>(state => state.router);

  const dispatch = useDispatch();
  const path = location.pathname;

  useEffect(() => {
    if (typeof token === 'string') {
      if (!token && path !== `/auth`) dispatch(push('/auth'));
      if (token && (path === `/auth` || path === '/')) dispatch(push('/live'));
    }
  }, [token, location.pathname]);
};

export default useInitialRouting